import {
  HORIZONTAL_GRID_GAP_PERCENTAGE,
  LAYOUT_MAP,
  VERTICAL_GRID_GAP_PERCENTAGE,
} from './constants';
import { getDotRadius } from './getDotRadius';

interface DotsGridDimensions {
  childWidth: number;
  childHeight: number;
  dotRadius: number;
}

const getElementSize = ({
  totalSize,
  numberOfElements,
  gap,
}: {
  totalSize: number;
  numberOfElements: number;
  gap: number;
}) => {
  const sizeWithoutGaps = totalSize - gap * (numberOfElements - 1);
  return sizeWithoutGaps / numberOfElements;
};

export const calculateDotsGridDimensions = ({
  width,
  height,
  count,
  largestNumberOfDots,
}: {
  width: number;
  height: number;
  count: number;
  largestNumberOfDots: number;
}): DotsGridDimensions | null => {
  if (count > 12 || count < 1) {
    return null;
  }

  const layout = LAYOUT_MAP[count]!;

  const horizontalGap =
    width > 1000
      ? width * HORIZONTAL_GRID_GAP_PERCENTAGE
      : (width * HORIZONTAL_GRID_GAP_PERCENTAGE) / 2;

  const verticalGap = height * VERTICAL_GRID_GAP_PERCENTAGE;

  const childWidth = getElementSize({
    totalSize: width,
    numberOfElements: Math.max(...layout),
    gap: horizontalGap,
  });
  const childHeight = getElementSize({
    totalSize: height,
    numberOfElements: layout.length,
    gap: verticalGap,
  });

  const dotRadius = getDotRadius({
    numberOfDots: largestNumberOfDots,
    width: childWidth,
    height: childHeight,
  });

  return { childWidth, childHeight, dotRadius };
};
